import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { shortTestimonials } from '../data/content';
import { Button } from './ui/Button';
import { Eyebrow, SectionTitle } from './ui/SectionHeading';
export function Testimonials() {
  return <section className="mx-auto max-w-6xl px-4 py-14 md:py-16" data-id="element-309" data-mp="3fy30s059k05m">
      <Eyebrow data-id="element-310" data-mp="3b1ckbbpjr2jo">⭐ Lo que dicen los que ya lo tienen</Eyebrow>
      <SectionTitle data-id="element-311" data-mp="3ayqd5d6kip1z">
        Entrenadores reales que ya tienen <span className="text-gold" data-id="element-312" data-mp="3700ub52rgfay">el año resuelto</span>
      </SectionTitle>
      <div className="mt-8 grid items-stretch gap-4 md:grid-cols-3" data-id="element-313" data-mp="31zcze8bevebg">
        {shortTestimonials.map(item => <article key={item.initials} className="relative flex flex-col rounded-2xl border border-line bg-surface p-6" data-id="element-314" data-mp="2x1upaelnqt1v">
            <QuoteIcon aria-hidden="true" className="absolute right-5 top-5 h-7 w-7 text-gold/20" data-id="element-315" data-mp="v9gavpibo6q7" />
            <p className="mb-4 text-sm text-gold" aria-label="5 de 5 estrellas" data-id="element-316" data-mp="qac393b1qh1z">
              ★★★★★
            </p>
            <blockquote className="mb-5 flex-1 text-base font-medium italic leading-relaxed text-zinc-300" data-id="element-317" data-mp="h5f0vqsro53b">
              “{item.text}”
            </blockquote>
            <div className="mt-auto flex items-center gap-3 border-t border-line pt-4" data-id="element-318" data-mp="m2yceiy2y3rk">
              <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-gold/40 bg-gold/10 text-sm font-bold text-gold" data-id="element-319" data-mp="79lfdhx2l19e">
                {item.initials}
              </span>
              <div data-id="element-320" data-mp="14u7omzz8j6mu">
                <p className="text-sm font-bold text-white" data-id="element-321" data-mp="14ur5edd5foza">{item.name}</p>
                <p className="text-xs text-zinc-500" data-id="element-322" data-mp="q5v1msi4ky4h">📍 {item.place}</p>
              </div>
            </div>
          </article>)}
      </div>
      <div className="mx-auto mt-8 max-w-3xl rounded-3xl border border-gold/40 bg-surface p-6 text-center" data-id="element-323" data-mp="v3d4c15juh41">
        <p className="text-sm font-extrabold uppercase tracking-wide text-gold" data-id="element-324" data-mp="1nm0jz11s13xq">
          ⏰ Precio de lanzamiento por tiempo limitado
        </p>
        <p className="mt-2 text-xl font-black text-white" data-id="element-325" data-mp="1xgpnflj2x8ct">
          Sumate hoy y dejá todo tu año de gimnasia{' '}
          <span className="text-gold" data-id="element-326" data-mp="1sjpcaw7dhfeu">armado en una tarde.</span>
        </p>
        <div className="mt-5" data-id="element-327" data-mp="1ofzr8gpwpfyk">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:text-base" data-id="element-328" data-mp="1ojf7hmvbgv1k">
            Quiero ver mi oferta del Combo Completo →
          </Button>
        </div>
      </div>
    </section>;
}